import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAPI, getAPI, postAPI, putAPI } from "../../service/http-service";
import { IStudentLead } from "../../portal/student/leads/IStudentLead";

const StudentLeadAPI = {
  student_lead: "lead",
  student_lead_list: "lead",
  student_lead_edit: "lead",
  student_lead_add: "lead",
  student_lead_deleteAll: "lead",
  student_lead_by_id: "lead",
  student_lead_delete_by_id: "lead",
  student_lead_view_by_id: "lead/view",
  student_lead_export_excel: "lead/export/excel",
  followUp: "lead",
  allFollowUp: "lead",
  workshopDoneDate: "lead",
  statistics: "lead/statistics",
  findAllByDate: "lead/findAllByDate",
};

export interface StudentLeadResponseData {
  data: IStudentLead[];
}

export interface StudentLeadResponse {
  data: any;
  message: string | undefined;
  errors: [string] | null;
}

export interface StudentLeadState {
  loading: boolean;
  studentLeadResponse: StudentLeadResponse;
  error: string | undefined;
}

const initialState: StudentLeadState = {
  loading: false,
  error: undefined,
  studentLeadResponse: {
    data: undefined,
    message: undefined,
    errors: null,
  },
};

export const studentLeadAction = createAsyncThunk(
  "master/studentLead",
  async (studentLead: any) => {
    // This is kept purposefully to check the data going
    try {
      let response;
      switch (studentLead.apiAction) {
        case "list":
          response = await getAPI(StudentLeadAPI.student_lead_list);
          break;
        case "update":
          response = await putAPI(
            StudentLeadAPI.student_lead_edit,
            studentLead.formValues
          );
          break;
        case "create":
          response = await postAPI(
            StudentLeadAPI.student_lead_add,
            studentLead.formValues
          );
          break;
        case "delete_All":
          response = await deleteAPI(
            `${StudentLeadAPI.student_lead_deleteAll}?${studentLead.requestParams}`
          );
          break;
        case "student_lead_by_id":
          response = await getAPI(
            `${StudentLeadAPI.student_lead_by_id}/${studentLead.leadId}`
          );
          break;
        case "student_lead_delete_by_id":
          response = await deleteAPI(
            `${StudentLeadAPI.student_lead_delete_by_id}/${studentLead.id}`
          );
          break;
        case "student_lead_view_by_id":
          response = await getAPI(
            `${StudentLeadAPI.student_lead_view_by_id}/${studentLead.leadId}`
          );
          break;
        case "exportExcel":
          response = await postAPI(
            StudentLeadAPI.student_lead_export_excel,
            studentLead.formValues
          );
          break;
        case "followUp":
          response = await putAPI(
            `${StudentLeadAPI.student_lead}/${studentLead.leadId}/followup`,
            studentLead.params
          );
          break;
        case "allFollowUp":
          response = await getAPI(
            `${StudentLeadAPI.student_lead}/${studentLead.id}/allFollowup`
          );
          break;
        case "nextFollowUpDate":
          response = await putAPI(
            `${StudentLeadAPI.student_lead}/${studentLead.id}/nextFollowUpDate`,
            studentLead.params
          );
          break;
        case "workshopDoneDate":
          response = await putAPI(
            `${StudentLeadAPI.student_lead}/${studentLead.leadId}/workshopDoneDate?workshopDoneDate=${studentLead.workshopDoneDate}`
          );
          break;
        case "statistics":
          response = await getAPI(
            StudentLeadAPI.statistics,
            studentLead.params
          );
          break;
        case "findAllByDate":
          response = await getAPI(
            StudentLeadAPI.findAllByDate,
            studentLead.params
          );
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const studentLeadSlice = createSlice({
  name: "student_lead",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.studentLeadResponse.data.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(studentLeadAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(studentLeadAction.fulfilled, (state, { payload }: any) => {
      state.loading = false;
      state.studentLeadResponse = payload;
    });
    builder.addCase(studentLeadAction.rejected, (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.studentLeadResponse.data = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const studentLeadReducer = studentLeadSlice.reducer;
export default studentLeadReducer;
